import { CompanyRecord } from '@monorepo/core/records'

export const ReducerRecord = CompanyRecord
